import { ExternalLink } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { useAdminAuth } from "@/lib/hooks/useAdminAuth";
import { createMerchantSSOToken } from "@/lib/api/admin";
import { merchantDashboardUrl } from "@/lib/utils/merchantUrl";

type MerchantDashboardLinkProps = {
  storeId: string;
  stopPropagation?: boolean;
};

export function MerchantDashboardLink({
  storeId,
  stopPropagation = false,
}: MerchantDashboardLinkProps) {
  const user = useAdminAuth();

  async function handleClick(e: React.MouseEvent) {
    e.preventDefault();
    if (stopPropagation) e.stopPropagation();
    // Opened synchronously, before any await, so browsers still treat it as user-initiated and don't block it.
    const tab = window.open("", "_blank");
    if (!user) return;
    try {
      const { token } = await createMerchantSSOToken(user);
      if (tab) tab.location.href = merchantDashboardUrl(storeId, token);
    } catch {
      tab?.close();
      toast.error("Could not open the merchant dashboard");
    }
  }

  return (
    <Button asChild variant="secondary" size="sm" className="h-6 px-2 text-[10px] font-medium">
      <a href={merchantDashboardUrl(storeId)} onClick={handleClick} title="Open merchant dashboard">
        <ExternalLink className="size-3 mr-1" />
        MD
      </a>
    </Button>
  );
}
